import {
  MatchParams as BusinessImageRoutesMatchParams,
  IMAGE_LIST_PATH,
} from 'components/ui/LargeImageGallery';
import { Lightbox, LightboxImage } from 'omakase';
import { getRootImageFlowPagePath } from 'routes/business/imageHistoryUtil';
import { useHistory, useRouteMatch } from 'react-router-dom';
import React from 'react';

interface MatchParams extends BusinessImageRoutesMatchParams {
  imageId?: string;
}

interface LightboxRouteProps {
  images: LightboxImage[];
  onClose: () => void;
}

const LightboxRoute: React.FunctionComponent<LightboxRouteProps> = ({ images, onClose }) => {
  const match = useRouteMatch<MatchParams>();
  const history = useHistory();

  const imageIdFromMatch = match.params.imageId;

  const getImageIndexFromId = (id: number) => images.findIndex((image) => image.id === id);
  const getImageIdFromIndex = (index: number) => images[index].id;

  const rootPath = React.useMemo(() => {
    return getRootImageFlowPagePath(match.url);
  }, [match.url]);

  const redirectToImageListPage = () => {
    history.replace(`${rootPath}/${IMAGE_LIST_PATH}`);
  };

  if (!imageIdFromMatch) {
    // No image id param passed - redirect to business page
    redirectToImageListPage();
    return null;
  }

  const index = getImageIndexFromId(parseInt(imageIdFromMatch));

  if (index < 0) {
    // No match for image id - redirect to business page
    redirectToImageListPage();
    return null;
  }

  const handleChangeIndex = (index: number) => {
    const newId = getImageIdFromIndex(index);
    history.replace(`${rootPath}/images/${newId}`, history.location.state);
  };

  return (
    <Lightbox
      open={true}
      index={index}
      images={images}
      onChangeIndex={handleChangeIndex}
      onClose={onClose}
    />
  );
};

export default LightboxRoute;
